import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaClock, FaCheckCircle, FaTruck, FaTimesCircle } from 'react-icons/fa';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3500';

function OrderNavigationStrip({ activeStatus, refreshTrigger }) {
    const [counts, setCounts] = useState({
        pendingOrdersCount:   0,
        confirmedOrdersCount: 0,
        shippedOrdersCount:   0,
        deliveredOrdersCount: 0,
        cancelledOrdersCount: 0
    });

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const { data } = await axios.get(`${API_BASE_URL}/order-counts`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (data.counts) setCounts(data.counts);
            } catch (error) {
                console.error('Error fetching order counts in navigation strip:', error);
            }
        };
        fetchCounts();
    }, [refreshTrigger]);

    const tiles = [
        {
            status:   'pending',
            title:    'PENDING ORDERS',
            count:    counts.pendingOrdersCount,
            link:     '/admin/pending-orders',
            Icon:     FaClock,
            iconBg:   'rgba(26, 35, 126, 0.08)',
            iconColor:'#1a237e',
            numColor: '#1a237e'
        },
        {
            status:   'confirmed',
            title:    'CONFIRMED ORDERS',
            count:    counts.confirmedOrdersCount,
            link:     '/admin/confirmed-orders',
            Icon:     FaCheckCircle,
            iconBg:   'rgba(21, 101, 192, 0.08)',
            iconColor:'#1565c0',
            numColor: '#1565c0'
        },
        {
            status:   'shipped',
            title:    'SHIPPED ORDERS',
            count:    counts.shippedOrdersCount,
            link:     '/admin/shipped-orders',
            Icon:     FaTruck,
            iconBg:   'rgba(0, 131, 143, 0.08)',
            iconColor:'#00838f',
            numColor: '#00838f'
        },
        {
            status:   'delivered',
            title:    'DELIVERED ORDERS',
            count:    counts.deliveredOrdersCount,
            link:     '/admin/delivered-orders',
            Icon:     FaCheckCircle,
            iconBg:   'rgba(46, 125, 50, 0.08)',
            iconColor:'#2e7d32',
            numColor: '#2e7d32'
        },
        {
            status:   'cancelled',
            title:    'CANCELLED ORDERS',
            count:    counts.cancelledOrdersCount,
            link:     '/admin/cancelled-orders',
            Icon:     FaTimesCircle,
            iconBg:   'rgba(211, 47, 47, 0.08)',
            iconColor:'#d32f2f',
            numColor: '#d32f2f'
        }
    ];

    return (
        <div className="row dashboard-stats-row orders-stats-row mb-4">
            {tiles.map((tile, idx) => {
                const isActive = tile.status === activeStatus;
                return (
                    <div
                        key={idx}
                        className={
                            idx === 4
                                ? 'col-lg col-md-12 col-sm-12'
                                : 'col-lg col-md-6 col-sm-12'
                        }
                    >
                        <Link
                            to={tile.link}
                            className={`card dashboard-stats-card text-decoration-none ${isActive ? 'active-stats-card' : ''}`}
                        >
                            {/* Icon + label */}
                            <div
                                className="d-flex align-items-center mb-3"
                                style={{ gap: 12 }}
                            >
                                <span
                                    className="stats-icon-wrapper"
                                    style={{
                                        background:     tile.iconBg,
                                        borderRadius:   8,
                                        width:          40,
                                        height:         40,
                                        display:        'flex',
                                        alignItems:     'center',
                                        justifyContent: 'center',
                                        flexShrink:     0
                                    }}
                                >
                                    <tile.Icon
                                        style={{ fontSize: 20, color: tile.iconColor }}
                                    />
                                </span>
                                <div>
                                    <div
                                        style={{
                                            fontSize:      12,
                                            color:         '#4b5563',
                                            fontWeight:    600,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                        }}
                                    >
                                        {tile.title}
                                    </div>
                                </div>
                            </div>

                            {/* Count */}
                            <div>
                                <div
                                    style={{
                                        fontSize:   28,
                                        fontWeight: 700,
                                        color:      tile.numColor,
                                        lineHeight: 1.2
                                    }}
                                >
                                    {tile.count}
                                </div>
                                <div
                                    style={{
                                        fontSize:   12,
                                        color:      '#6b7280',
                                        fontWeight: 500,
                                        marginTop:  4
                                    }}
                                >
                                    orders
                                </div>
                            </div>
                        </Link>
                    </div>
                );
            })}
        </div>
    );
}

export default OrderNavigationStrip;
